module.exports = __webpack_public_path__ + "static/media/speachInactive.85f96105.svg";